<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="search.kname" @change="Search" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.code" @change="Search" placeholder="品牌标识"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="AddBrand">增加品牌</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <el-table-column label="名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="EditBrand(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="DeleteBrand(scope.row)">删除</el-button>
          <router-link :to="'/iotmanage/brand/media/' + scope.row.code" style="margin-left:10px">
            <el-button type="info" size="small">社媒</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title + '品牌'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="品牌名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="品牌code" prop="code" label-width="100px">
          <el-input :disabled="edit" v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="社媒邮箱" prop="manager_email" label-width="100px">
          <el-input v-model="form.manager_email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="Validate(Addconfirm)">{{edit?'修改':'新增'}}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import util from '../../../util/util'
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        kname: '',
        code: '',
      },
      list: [],
      total: 0,
      title: '',
      dialogFormVisible: false,
      form: {
        code: '',
        name: '',
        manager_email: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入code', trigger: 'blur' }],
      },
      edit: false,
      checkList: ['选中且禁用','复选框 A']
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search () {
      this.api.BrandList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    AddBrand () {
      this.form = {}
      this.edit = false
      this.dialogFormVisible = true
      this.title = '新增'
    },
    EditBrand(item) {
      this.form = {}
      this.edit = true
      this.title = '编辑'
      this.api.BrandDetail({
        code: item.code
      }).then(res => {
        if (res.data.code == 200) {
          this.form = res.data.data
          this.dialogFormVisible = true
          return
        }
        this.$message.error('获取详情失败' + res.data.msg)
      })
    },
    DeleteBrand(item) {
      this.$confirm('是否删除该品牌?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.BrandDelete({
          code: item.code
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({type: 'success',message: '删除成功!'});
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    Validate (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    Addconfirm () {
      this.api.BrandUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.$message.success('新增成功')
          this.Search()
          this.dialogFormVisible = false
          return
        }
        this.$message.error('新增失败' + res.data.msg)
      })
    },
    ChangeTime (item) {
      return util.dateFormat(item)
    }
  },
  filters: {},
  mounted () {
    this.Search()
  },
  created () { }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
